import styled from '../../../styles/theme';
import { MarketingStickerStyled } from '../MarketingStickerStyled';
import { rem } from 'polished';

export const MarketingStickerStyledAP = styled(MarketingStickerStyled)`
    background: rgba(0, 163, 224, 0.3);
    color: ${({ theme }) => theme.colors.primaryBlack};
`;
